// extracted by mini-css-extract-plugin
export default {"fixedHeight":"CardErrorHandler_fixedHeight__Gsvcq"};